// extracted by mini-css-extract-plugin
module.exports = {"formKontrol":"pickCountry_formKontrol__2tRJr"};